module.exports = __webpack_public_path__ + "img/tab-active.efe8561b.png";